import { portfolioButtonStyles } from '../../../../../styles';

export default theme => ({
  ...portfolioButtonStyles(theme),
  paper: {
    // border: '5px solid black',
    width: '20rem',
    left: '0%',
    cursor: 'pointer',
    // right: '0%',
    // marginRight: '-10px',
    // display: 'inline-block',
    position: 'absolute',

    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      width: '100%',
    },
  },
  amountField: {
    '& .MuiOutlinedInput-root': {
      padding: '0px !important',
    },
  },
});
